"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs3/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _construct = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/reflect/construct"));

var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

require("../../../util/GlobalScript.js");

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _PropUtils = require("../../../util/PropUtils");

var _classnames = _interopRequireDefault(require("classnames"));

var _underscore = _interopRequireDefault(require("underscore"));

var _PopoverNavMenu = _interopRequireDefault(require("../../tooltips/PopoverNavMenu"));

var _HeaderNav = _interopRequireDefault(require("./HeaderNav"));

var _EnvironmentSelector = _interopRequireDefault(require("./EnvironmentSelector"));

var _FlexRow = _interopRequireWildcard(require("../../layout/FlexRow"));

var _MarketSelector = _interopRequireDefault(require("./MarketSelector"));

var _Logo = _interopRequireDefault(require("./logos/Logo"));

var _NavHomeButton = _interopRequireDefault(require("../NavFrame/NavHomeButton"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = (0, _construct.default)(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct.default) return false; if (_construct.default.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct.default)(Date, [], function () {})); return true; } catch (e) { return false; } }

/**
 *  @typedef {function} HeaderBar~MenuRenderer
 *  @desc Function for overriding default rendering
 *  @param {PopoverMenu} props
 *      Object of props that can be passed to the component
 *  @param {object} DefaultComponent
 *      The component that encompasses the default rendering. Accepts props from the props parameter
 */

/**
 * @class HeaderBar~NavItem
 * @desc Internal component type which will render a product-nav item and optional a corresponding menu
 *
 * @param {string} id
 *          The id of the component.  Determines the icon
 * @param {string} [data-id="nav-item"]
 *          To define the base "data-id" value for the top-level HTML container.
 * @param {string} [title]
 *          Sets the title attribute of the label (tooltip)
 * @param {string} [target=_blank]
 *          This may be "" or "_blank"
 * @param {string} [url]
 *          If provided the NavItem will be a clickable link instead of executing a callback
 * @param {string} [iconClassName]
 *          The className for the menu icon. Takes priority over the iconSrc prop.
 * @param {string} [iconSrc]
 *          Allows the passage of an image url (most likely an svg) for the icon.
 * @param {boolean} [open=false]
 *          Menu state while this is defined, if it's not defined, it's managed internally to this component and doesn't
 *          require the developer to do anything when they use the headerbar.
 * @param {HeaderBar~MenuRenderer} renderMenu
 *          Renders the popup menu
 */
var NavItem = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(NavItem, _React$Component);

  var _super = _createSuper(NavItem);

  function NavItem() {
    var _context;

    var _this;

    (0, _classCallCheck2.default)(this, NavItem);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, (0, _concat.default)(_context = [this]).call(_context, args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_handleMenuToggle", function () {
      _this.props.onMenuToggle(_this.props.id);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_handleMenuClick", function (value) {
      _this.props.onMenuValueChange(value, _this.props.id);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_getIcon", function (item) {
      if (item.iconSrc) {
        return /*#__PURE__*/_react.default.createElement("img", {
          src: item.iconSrc,
          className: "product-nav__image icon"
        });
      } else {
        var iconClassName = (0, _PropUtils.getIconClassName)(item, {
          useId: true
        });
        return /*#__PURE__*/_react.default.createElement("span", {
          className: (0, _classnames.default)("product-nav__icon", "icon", iconClassName)
        });
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_getMenuChildren", function () {
      var _context2;

      return (0, _map.default)(_context2 = _this.props.children).call(_context2, function (child) {
        return _underscore.default.defaults(child, {
          "data-id": child.id,
          onClick: function onClick() {
            return _this._handleMenuClick(child.id);
          }
        });
      });
    });
    return _this;
  }

  (0, _createClass2.default)(NavItem, [{
    key: "render",
    value: function render() {
      var renderMenu = this.props.renderMenu;
      return /*#__PURE__*/_react.default.createElement("li", {
        className: "product-nav__item"
      }, this.props.children ? renderMenu({
        "data-id": this.props["data-id"],
        label: this._getIcon(this.props),
        title: this.props.label,
        placement: "left",
        items: this._getMenuChildren(),
        open: this.props.open,
        onOpen: this._handleMenuToggle,
        onClose: this._handleMenuToggle,
        triggerClassName: "product-nav__menu-trigger"
      }, _PopoverNavMenu.default) : /*#__PURE__*/_react.default.createElement("a", {
        className: "product-nav__link",
        onClick: this.props.onClick,
        href: this.props.url,
        "data-id": this.props["data-id"],
        title: this.props.title,
        target: this.props.target
      }, this._getIcon(this.props)));
    }
  }]);
  return NavItem;
}(_react.default.Component);
/**
 *  @typedef {function} HeaderBar~ItemRenderer
 *  @desc Function for overriding default rendering
 *  @param {HeaderBar~NavItem} props
 *      Object of props that can be passed to the component
 *  @param {object} DefaultComponent
 *      The component that encompasses the default rendering. Accepts props from the props parameter
 */

/**
 * @class HeaderBar~ProductNav
 * @desc Internal component type which will renders a Product Nav based on tree
 *
 * @param {string} [data-id="nav-item"]
 *          To define the base "data-id" value for the top-level HTML container.
 * @param {array} tree
 *          The data structure of the menus of the headerbar
 * @param {HeaderBar~ItemRenderer} renderNavItem
 *          Function to render a nav item
 * @param {function} onMenuToggle
 *          Callback for opening the menu
 * @param {HeaderBar~onMenuValueChange} [onMenuValueChange]
 *          Callback which will be executed when a menu item is clicked.  The id
 *          of the nav item and the id of the menu item will be passed back as parameters 1 and 2.
 * @param {string} openNode
 *          Id of the open node
 * @param {HeaderBar~navigationLink[]} tree
 *          The data structure of the menus of the headerbar
 *
 */


(0, _defineProperty2.default)(NavItem, "propTypes", {
  id: _propTypes.default.string.isRequired,
  "data-id": _propTypes.default.string,
  label: _propTypes.default.string,
  title: _propTypes.default.string,
  target: _propTypes.default.string,
  url: _propTypes.default.string,
  iconClassName: _propTypes.default.string,
  iconSrc: _propTypes.default.string,
  onClick: _propTypes.default.func,
  open: _propTypes.default.bool,
  children: _propTypes.default.array,
  onMenuToggle: _propTypes.default.func,
  onMenuValueChange: _propTypes.default.func,
  renderMenu: _propTypes.default.func
});
(0, _defineProperty2.default)(NavItem, "defaultProps", {
  target: "_blank",
  "data-id": "nav-item",
  onClick: _underscore.default.noop,
  onMenuToggle: _underscore.default.noop,
  onMenuValueChange: _underscore.default.noop,
  renderMenu: _PropUtils.defaultRender
});

var ProductNav = function ProductNav(_ref) {
  var dataId = _ref["data-id"],
      onMenuToggle = _ref.onMenuToggle,
      onMenuValueChange = _ref.onMenuValueChange,
      openNode = _ref.openNode,
      renderNavItem = _ref.renderNavItem,
      tree = _ref.tree;

  var getNavItem = function getNavItem(item) {
    var props = _underscore.default.defaults({
      key: item.id,
      id: item.id,
      "data-id": item.id,
      onMenuToggle: onMenuToggle,
      onMenuValueChange: onMenuValueChange
    }, item);

    if (openNode !== undefined) {
      props.open = item.id === openNode;
    }

    return renderNavItem(props, NavItem);
  };

  return /*#__PURE__*/_react.default.createElement("ul", {
    className: "product-nav",
    "data-id": dataId
  }, (0, _map.default)(_underscore.default).call(_underscore.default, tree, getNavItem));
};

ProductNav.propTypes = {
  "data-id": _propTypes.default.string,
  onMenuToggle: _propTypes.default.func.isRequired,
  onMenuValueChange: _propTypes.default.func.isRequired,
  renderNavItem: _propTypes.default.func,
  tree: _propTypes.default.arrayOf(_propTypes.default.object).isRequired
};
ProductNav.defaultProps = {
  renderNavItem: _PropUtils.defaultRender
};
/**
 *  @typedef {function} HeaderBar~ProductNavRenderer
 *  @desc Function for overriding default rendering
 *  @param {HeaderBar~ProductNav} props
 *      Object of props that can be passed to the component
 *  @param {object} DefaultComponent
 *      The component that encompasses the default rendering. Accepts props from the props parameter
 */

/**
 * @typedef HeaderBar~navigationLink
 * @desc Look at HeaderBar#NavItem to understand what can be passed.
 * @property {string} [data-id]
 *          To define the base "data-id" value for the top-level HTML container.
 * @property {string} id
 *          Identifier of the link, as well as for the icon. It is formatted "icon-"+id for the icon class.
 * @property {string} [title]
 *          Link title.
 * @property {string} [label]
 *          Display label for the header link. Typically only used by dropdown links, defined in children.
 * @property {string} [url]
 *          Url for link to direct to
 * @property {string} [target="_blank"]
 *          Target window for url, which will default to a new window/tab.
 * @property {HeaderBar~navigationLink[]} [children]
 *          The array of navigationLinks are links display in a dropdown menu, which can contain all of the
 *          same properties defined in a regular link, excluding children, as we only support one level deep.
 */

/**
 * @class HeaderBar
 * @desc HeaderBar provides what you need to show a styled top bar with logos, links, and a menu.
 *
 * @param {string} [data-id="header-bar"]
 *          To define the base "data-id" value for the top-level HTML container.
 * @param {string|object} [additionalContent]
 *          Content to display to the right of the "siteLogo" and "siteTitle"
 * @param {array} [environmentOptions]
 *          Choices for environment in the environment selector
 * @param {string} [environmentSearch]
 *          Query string for the environment selector's search
 * @param {string|number} [environmentSelected]
 *          Current environment selected by the environment selector
 * @param {boolean} [inline=false]
 *          When true, the header bar is positioned inline with the content, not at the top of the page
 * @param {string|number} [logoHeight]
 *          When specified, sets the height of the logo image and removes the max-width for it.
 * @param {array} [navOptions]
 *          Choices in the header nav
 * @param {string|number} [navSelected]
 *          Active item in the header nav
 * @param {HeaderBar~onEnvironmentChange} [onEnvironmentChange]
 *          Callback for when the selected environment changes.
 * @param {function} [onEnvironmentSearch]
 *          Callback for the search field in the environment selector
 * @param {HeaderBar~onNewEnvironment} [onNewEnvironment]
 *          Callback for when the user clicks the "+New Environment" link.
 * @param {string} [newEnvironmentLabel = "+ New environment"]
 *          Label for the "+ New environment" link
 * @param {HeaderBar~onItemValueChange} [onItemValueChange]
 *          Callback which will be executed when a header link is clicked.  The id
 *          of the nav item will be passed back as the first parameter
 * @param {HeaderBar~onMenuValueChange} [onMenuValueChange]
 *          Callback which will be executed when a menu item is clicked.  The id
 *          of the nav item and the id of the menu item will be passed back as parameters 1 and 2.
 * @param {HeaderBar~onNavChange} [onNavChange]
 *          Callback for when the selected nav item changes.
 * @param {HeaderBar~onMarketChange} [onMarketChange]
 *          Callback for when the selected market changes.
 * @param {string} [openNode]
 *          The id of the currently open node
 * @param {array} [marketOptions]
 *          Choices for market in the market selector
 * @param {string|number} [marketSelected]
 *          Current market selected by the market selector
 * @param {string} [siteLogo]
 *          Site or service specific logo
 * @param {string|object} [siteTitle]
 *          Content to display to the right of the "siteLogo" and to the left of "additionalContent"
 * @param {HeaderBar~navigationLink[]} tree
 *          The data structure of the menus of the headerbar
 * @param {array} [userMenu]
 *          Alternative to the tree prop. If you just want a single user menu, provide the options here
 * @param {string} [userName]
 *          Used as the label for the user menu
 * @param {boolean} [legacy]
 *          Flag to explicitly indicate you're using the old style of the header bar.
 * @param {HeaderBar~ProductNavRenderer} renderProductNav
 *          Function that renders the product nav. Accepts props as the first argument and the default component as the second.
 * @param {string|object} [mode]
 *          Mode of the app "sandbox". Eiher title of the mode or object with title and color.
 */

/**
 * @callback HeaderBar~onEnvironmentChange
 * @param {string} environment
 *          Environment id.
 */

/**
 * @callback HeaderBar~onNewEnvironment
 */

/**
 * @callback HeaderBar~onItemValueChange
 * @desc The id of the nav item will be passed back as the first parameter
 * @param {string} id
 *          Nav item identifier.
 */

/**
 * @callback HeaderBar~onMenuValueChange
 * @desc The id of the nav item and the id of the menu item will be passed back as parameters 1 and 2.
 * @param {string} navItemId
 *          Nav item identifier.
 * @param {string} navItemId
 *          Menu item identifier.
 */

/**
 * @callback HeaderBar~onNavChange
 * @param {string} currentNav
 *          Nav id.
 */

/**
 * @callback HeaderBar~onMarketChange
 * @param {string} market
 *          Market id.
 */

var HeaderBar = /*#__PURE__*/function (_React$Component2) {
  (0, _inherits2.default)(HeaderBar, _React$Component2);

  var _super2 = _createSuper(HeaderBar);

  function HeaderBar() {
    var _context3;

    var _this2;

    (0, _classCallCheck2.default)(this, HeaderBar);

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    _this2 = _super2.call.apply(_super2, (0, _concat.default)(_context3 = [this]).call(_context3, args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this2), "_handleMenuToggle", function (id) {
      return _this2.props.onItemValueChange(id);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this2), "_isUpdated", function () {
      return _this2.props.environmentOptions || _this2.props.navOptions || _this2.props.marketOptions || !_this2.props.legacy;
    });
    return _this2;
  }

  (0, _createClass2.default)(HeaderBar, [{
    key: "_getModeNodes",
    value: function _getModeNodes() {
      var mode = this.props.mode;

      if (!mode) {
        return {};
      }

      var bar = /*#__PURE__*/_react.default.createElement("div", {
        className: "header-bar__mode-bar",
        style: {
          backgroundColor: mode.color
        }
      });

      var title = /*#__PURE__*/_react.default.createElement("div", {
        className: "header-bar__mode-title",
        style: {
          borderColor: mode.color
        }
      }, //pull the property from an object if it is one, otherwise assume mode is string (proptypes)
      mode.title || mode);

      return {
        bar: bar,
        title: title
      };
    }
  }, {
    key: "render",
    value: function render() {
      var tree = this.props.tree;

      if (this.props.tree === undefined && this.props.userMenu) {
        tree = [{
          id: "account",
          label: this.props.userName,
          children: this.props.userMenu
        }];
      }

      var _this$props = this.props,
          renderProductNav = _this$props.renderProductNav,
          openNode = _this$props.openNode;

      var modeNodes = this._getModeNodes();

      return /*#__PURE__*/_react.default.createElement("div", {
        className: "header-bar",
        id: !this.props.inline ? "header" : "",
        "data-id": this.props["data-id"]
      }, modeNodes.bar, /*#__PURE__*/_react.default.createElement("div", {
        className: "header-bar__left"
      }, !this._isUpdated() && /*#__PURE__*/_react.default.createElement("div", {
        className: "header-bar__ping-logo",
        "data-id": "header-logo"
      }), this.props.homeButtonProps ? /*#__PURE__*/_react.default.createElement(_NavHomeButton.default, this.props.homeButtonProps) : null, /*#__PURE__*/_react.default.createElement(_FlexRow.default, {
        alignment: _FlexRow.alignments.BOTTOM,
        spacing: _FlexRow.spacingOptions.SM
      }, this.props.siteLogo && (_underscore.default.contains(["pingone", "uilib", "pingaccess", "pingfed"], this.props.siteLogo) ? /*#__PURE__*/_react.default.createElement(_Logo.default, {
        className: "header-bar__site-logo",
        "data-id": this.props["data-id"] + "-site-logo",
        id: this.props.siteLogo
      }) : /*#__PURE__*/_react.default.createElement("img", {
        alt: "Logo",
        className: "header-bar__site-logo",
        "data-id": this.props["data-id"] + "-site-logo",
        src: this.props.siteLogo,
        style: this.props.logoHeight ? {
          height: this.props.logoHeight,
          maxWidth: "none"
        } : {}
      })), this.props.siteTitle && /*#__PURE__*/_react.default.createElement("span", {
        className: "header-bar__site-title",
        "data-id": this.props["data-id"] + "-site-title"
      }, this.props.siteTitle), this.props.additionalContent && /*#__PURE__*/_react.default.createElement("span", {
        className: "header-bar__additional-content",
        "data-id": this.props["data-id"] + "-additional-content"
      }, this.props.additionalContent)), this.props.marketOptions && /*#__PURE__*/_react.default.createElement(_MarketSelector.default, {
        options: this.props.marketOptions,
        market: this.props.marketSelected,
        onMarketChange: this.props.onMarketChange
      })), /*#__PURE__*/_react.default.createElement("div", {
        className: "header-bar__center"
      }, this.props.navOptions && /*#__PURE__*/_react.default.createElement(_HeaderNav.default, {
        options: this.props.navOptions,
        currentNav: this.props.navSelected,
        onNavChange: this.props.onNavChange,
        renderNavItem: this.props.renderNavItem
      })), /*#__PURE__*/_react.default.createElement("div", {
        className: "header-bar__right"
      }, modeNodes.title, this.props.environmentOptions && /*#__PURE__*/_react.default.createElement(_EnvironmentSelector.default, {
        options: this.props.environmentOptions,
        environment: this.props.environmentSelected,
        search: this.props.environmentSearch,
        onEnvironmentChange: this.props.onEnvironmentChange,
        onSearch: this.props.onEnvironmentSearch,
        onNewEnvironment: this.props.onNewEnvironment,
        newEnvironmentLabel: this.props.newEnvironmentLabel
      }), tree && renderProductNav({
        "data-id": "".concat(this.props["data-id"], "-product-nav"),
        onMenuToggle: this._handleMenuToggle,
        onMenuValueChange: this.props.onMenuValueChange,
        openNode: openNode,
        tree: tree
      }, ProductNav)));
    }
  }]);
  return HeaderBar;
}(_react.default.Component);

(0, _defineProperty2.default)(HeaderBar, "propTypes", {
  "data-id": _propTypes.default.string,
  additionalContent: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object]),
  environmentOptions: _propTypes.default.arrayOf(_propTypes.default.object),
  environmentSearch: _propTypes.default.string,
  environmentSelected: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  inline: _propTypes.default.bool,
  logoHeight: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  mode: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.shape({
    title: _propTypes.default.string,
    color: _propTypes.default.string
  })]),
  navOptions: _propTypes.default.arrayOf(_propTypes.default.object),
  navSelected: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  newEnvironmentLabel: _propTypes.default.string,
  onEnvironmentChange: _propTypes.default.func,
  onEnvironmentSearch: _propTypes.default.func,
  onNewEnvironment: _propTypes.default.func,
  onItemValueChange: _propTypes.default.func,
  onMenuValueChange: _propTypes.default.func,
  onNavChange: _propTypes.default.func,
  onMarketChange: _propTypes.default.func,
  openNode: _propTypes.default.string,
  marketOptions: _propTypes.default.arrayOf(_propTypes.default.object),
  marketSelected: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  siteLogo: _propTypes.default.string,
  siteTitle: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object]),
  tree: _propTypes.default.arrayOf(_propTypes.default.object),
  userMenu: _propTypes.default.arrayOf(_propTypes.default.object),
  userName: _propTypes.default.string,
  renderProductNav: _propTypes.default.func,
  renderNavItem: _propTypes.default.func,
  legacy: _propTypes.default.bool
});
(0, _defineProperty2.default)(HeaderBar, "defaultProps", {
  inline: false,
  onEnvironmentChange: _underscore.default.noop,
  onItemValueChange: _underscore.default.noop,
  onNavChange: _underscore.default.noop,
  onMenuValueChange: _underscore.default.noop,
  onMarketChange: _underscore.default.noop,
  "data-id": "header",
  renderProductNav: _PropUtils.defaultRender,
  renderNavItem: _PropUtils.defaultRender,
  legacy: false
});
module.exports = HeaderBar;
module.exports.defaultRender = _PropUtils.defaultRender;